import styled from 'styled-components';
import { C } from '../../../../../theme/tokens';

export const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  // height: 87vh;
  flex: 1;
  border-bottom: 0.5px solid #f1f3f5;

  .title {
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
  }

  .elements {
    display: flex;
    gap: 4px;

    .input {
      height: 36px;
      padding: 8px 12px;
      border-radius: 4px;
      border-color: #ced4da;

      &.error {
        border-color: red !important;
      }

      input {
        height: 100%;
        font-size: 14px;
        font-weight: 400;
        color: #000;
      }
    }
  }
`;

export const FormElement = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .amount {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
  }

  .label {
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;

    .checkbox {
      margin-top: 2px;
    }
  }

  .required {
    color: red;
  }

  .input {
    height: 36px;
    padding: 0 8px;

    &.error {
      border-color: red !important;
    }
  }

  .tabs {
    display: flex;
    align-items: center;
    gap: 4px;

    button {
      width: 89px;
    }

    .tab {
      border: 1px solid #f1f3f5;
      background-color: #f1f3f5;
    }
  }
`;

export const Footer = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  background-color: white;
`;

export const Table = styled.table`
  width: 100%;
  border: 1px solid #f1f3f5;
  border-radius: 8px 8px 0 0 !important;
  // overflow: hidden;
`;

export const TableHeader = styled.thead`
  width: 100%;
  background-color: ${C.gray0};

  tr {
    th {
      padding: 10px 12px;
      color: ${C.gray6};
      font-size: 11px;
      font-style: normal;
      font-weight: 700;
      line-height: 140%;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      text-align: left;
      border-right: 1px solid ${C.gray1};
      vertical-align: middle;

      /* A caption belongs over its own column. Base Currency was centred while its cell is
         left-aligned, and Final Reporting / Type / Master Fund were left-aligned while their cells
         are centred by \`.reporting\` below — each one sat over the wrong edge. */
      &:nth-child(3) {
        min-width: 170px;
      }
      &:nth-child(4) {
        min-width: 150px;
      }
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7) {
        text-align: center;
      }

      &:nth-child(8) {
        width: 40px;
        text-align: center;
      }

      /* Opt-in column widths for the redesigned ESMA layout only. They are keyed to that table's
         column order, and this thead is shared with the Form PF table whose 4th and 5th columns are
         NFA ID and LEI ID — squeezing those to a checkbox width would be a regression there, so the
         legacy tables keep the widths above untouched.

         Captions are kept on one line because they wrapped ("NIL / RETURN", "FINAL / REPORTING"),
         which made the whole header band taller than the text in it. */

      .regulator {
        width: 100%;
        display: flex;
        gap: 8px;

        .count {
          color: ${C.gray5};
        }
      }
    }
  }
`;

export const TableBody = styled.tbody`
  width: 100%;

  /* Rows answer the pointer. This lived only on the Form PF subclass, so the ESMA table — the one
     with a code to type in every row — gave no feedback at all about which row you were on. */
  tr {
    transition: background-color 0.1s ease;

    &:hover td:not(.not_included) {
      background-color: ${C.gray0};
    }

    td {
      border: 1px solid ${C.gray1};
      padding: 8px 12px;

      &:nth-child(5) {
        max-width: 300px;
      }

      /* Excluded rows were #f9fafb against a #f8f9fa hover — the same grey to the eye, so "not
         filed here" and "your pointer is here" looked identical. One step further back now. */
      &.not_included {
        background-color: ${C.gray1};
      }

      .label {
        display: flex;
        align-items: center;
        gap: 8px;
        color: ${C.dark7};

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 19.6px */

        .checkbox {
          margin-top: 2px;
        }
      }

      .reporting {
        width: 100%;
        // max-width: 78px;
        display: flex;
        justify-content: center;
      }

      &.regulator {
        padding: 8px 12px;
        color: ${C.dark7};
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
      }
    }
  }
`;

export const TableBodyFormPF = styled(TableBody)`
  tr {
    /* Hover now comes from TableBody, which this extends. */
    td {
      vertical-align: middle;

      &:nth-child(8) {
        width: 40px;
        text-align: center;
      }
    }
  }
`;

export const Badge = styled.button`
  border-radius: 4px;
  border: 1px solid #228be6;
  background: #fff;
  padding: 12px 12px 12px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  width: auto;
  align-self: flex-start;

  span {
    color: #25262b;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .label {
    color: #25262b;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 19.6px */

    .checkbox {
      margin-top: 2px;
    }
  }
`;

export const Actions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;

  .add {
    color: #228be6;
  }

  .delete {
    display: flex;
    align-items: center;
    color: #fa5252;
    gap: 8px;

    svg {
      path {
        fill: #fa5252;
      }
    }
  }
`;

export const BottomActions = styled.div`
  width: 100%;
  display: flex;

  button {
    padding: 0 16px;
    border: 1px solid #228be6;
    border-radius: 4px;
    color: #228be6;
    display: flex;
    gap: 8px;
    color: #228be6;
    align-items: center;
    height: 32px;
  }
`;

/* ---------------------------------------------------------------------------------------------
   The fund list of the redesigned layout. A record, not a table row.

   The table forced one width per column on every fund, and three of its columns only apply to some
   of them: a master fund belongs to a feeder, the actions menu to a custom master fund. Every other
   record paid for those columns in width and got a disabled control to look at. On a grid the
   record keeps the alignment — the controls still stand in columns down the page, which is what
   makes a list scannable — but a field that applies to one record can appear on its own line there
   and nowhere else.

   The geometry is deliberately dense: 44px a record, the same as the table row it replaces, so a
   jurisdiction with forty funds is no longer to scroll through than it was.
   --------------------------------------------------------------------------------------------- */

/* The name is capped rather than given the remainder: left to take everything it put half a screen
   between a fund and its own code on a wide monitor. What is left over goes to the empty column at
   the end, so the fields stay together and the background still runs the full width of the pane. */
/* One geometry, always. The master fund's place is held whether or not anyone is a feeder, so
   clicking Feeder fills a space that was already there instead of resizing every column in the
   list. Reserving it costs nothing: what sits there otherwise is whitespace with no caption over
   it — not the column of disabled boxes the table used to draw.

   It comes directly after Type, before the actions, so "Feeder — of Alamo Capital Partners" reads
   as one phrase rather than across a gap. */
// Type column bumped from 104 → 200 to comfortably fit the SegmentedControl with a reserved
// × slot inside each pill (icon + gap per pill × 3 pills of extra content, plus room to breathe).
const RECORD_COLUMNS = 'minmax(180px, 260px) 110px 96px 70px 100px 200px 240px 40px';

/* Below 1200px the fixed fields leave the name under its minimum: the gaps tighten, the master
   fund track goes, and a feeder's field takes the row beneath. */
const RECORD_NARROW = 'minmax(160px, 1fr) 110px 96px 70px 200px 160px 40px';
const RECORD_LINE =
  '1px solid light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-5))';
const RECORD_MUTED = 'light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-1))';

export const RecordHead = styled.div`
  display: grid;
  grid-template-columns: ${RECORD_COLUMNS};
  align-items: end;
  gap: 20px;
  padding: 8px 20px;

  @container (max-width: 1200px) {
    grid-template-columns: ${RECORD_NARROW};
    gap: 12px;
  }

  border-bottom: ${RECORD_LINE};
  background: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6));

  /* The captions stay put while the funds scroll under them; at forty records the alternative is
     scrolling back up to find out which column you are in. */
  position: sticky;
  top: 0;
  z-index: 2;

  > span,
  > .regulator > span {
    /* The same heading the lookup and output tables use: 13px, 600, no caps and no tracking. Small
       uppercase with letter-spacing is not what a column is called anywhere else in the app.

       One line each. The two checkbox columns are as wide as their captions ask for, because the
       space is there to give: whatever the fields don't use goes to the empty column at the end. */
    white-space: nowrap;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    color: light-dark(var(--mantine-color-gray-7), var(--mantine-color-dark-0));
  }

  .regulator {
    display: flex;
    align-items: baseline;
    gap: 8px;
    min-width: 0;
  }

  .regulator .count {
    font-size: 12px;
    font-weight: 400;
    color: light-dark(var(--mantine-color-gray-5), var(--mantine-color-dark-2));
  }
`;

/* The list is what the records measure themselves against — not the window, which says nothing
   about how much room this pane actually has beside the rail and the chat panel. */
export const RecordList = styled.div`
  container-type: inline-size;
`;

export const Record = styled.div`
  border-bottom: 1px solid light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-6));
  transition: background-color 0.1s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6));
  }

  /* A fund that is not filed in this jurisdiction. Nothing in the record is required, counted or
     checked while the box is clear — no code demanded, no uniqueness test, no master fund, and it
     stays out of the "4 of 4 coded" count — so the fields say as much by stepping back. Muting only
     the name, as this did before, left every control looking as live as the rows that count.

     They are dimmed, not disabled: a code typed before the fund is switched on is still a code.
     The checkbox itself keeps full contrast — it is the way back. */
  &[data-excluded='true'] .label {
    color: light-dark(var(--mantine-color-gray-5), var(--mantine-color-dark-2));
  }

  &[data-excluded='true'] > * > *:not(.label) {
    opacity: 0.45;
  }
`;

export const RecordMain = styled.div`
  display: grid;
  grid-template-columns: ${RECORD_COLUMNS};
  align-items: center;
  gap: 20px;
  padding: 6px 20px;
  min-height: 44px;
  font-size: 13px;
  line-height: 18px;

  .label {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    font-size: 13px;
    line-height: 18px;
    color: ${C.dark7};
  }

  .elements,
  .reporting {
    min-width: 0;
  }

  .reporting {
    display: flex;
    justify-content: center;
  }

  /* Unanswered, not broken. Outline instead of border to keep the 32px. */
  .reporting[data-unset] .mantine-SegmentedControl-root {
    outline: 1px dashed light-dark(var(--mantine-color-gray-4), var(--mantine-color-dark-3));
    outline-offset: -1px;
  }

  /* Text fields and selects only. A Mantine checkbox IS its input — the visible box is the input
     element — so a blanket height turned each one into a 32px-tall sliver. The segmented control's
     radios are inputs too. */
  input:not([type='checkbox']):not([type='radio']),
  .input,
  .mantine-Select-input {
    min-height: 32px;
    height: 32px;
    font-size: 13px;
    /* The shared Input sets 500, which made the national codes the heaviest text in the record —
       heavier than the fund's own name and than the column headings above them. */
    font-weight: 400;
    border-color: light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
  }

  input:not([type='checkbox']):not([type='radio']):hover,
  .mantine-Select-input:hover {
    border-color: light-dark(var(--mantine-color-gray-4), var(--mantine-color-dark-3));
  }

  /* The master fund of a feeder finishes that fund's own line — "feeder of X" — in the space after
     Type that every other record leaves empty. No column for the funds that don't have one, no
     second line to align, and no caption: it stands next to the word that calls for it. */
  /* Both cells are placed by hand: the master fund's is empty on every record that isn't a feeder,
     and an auto-placed empty cell would let the actions slide into its track. */
  /* Mantine rings a focused control with 2px of primary colour, 2px clear of it. Around a 16px
     checkbox that is a 24px blue square, and Chrome counts a click on a checkbox as keyboard focus,
     so it stays there after ticking one — it reads as an error, not as "you are here". Kept, since
     it is how anyone on a keyboard knows where they are, but at the weight of this page. */
  input:focus-visible,
  .mantine-Checkbox-input:focus-visible {
    outline-width: 1px;
    outline-offset: 1px;
    border-radius: 4px;
  }

  .masterCell {
    grid-column: 7;
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
  }

  .masterCell:empty {
    display: none;
  }

  .actionsCell {
    grid-column: 8;
    min-width: 0;
  }

  .masterCell .of {
    flex-shrink: 0;
    font-size: 12px;
    color: light-dark(var(--mantine-color-gray-5), var(--mantine-color-dark-2));
  }

  .masterCell .field {
    flex: 1;
    min-width: 0;
    max-width: 240px;
  }

  /* Several master funds wrap onto several lines, and the field grows with them. What has to be
     right is the detail: Mantine centres its chevron in whatever height the field ends up, which
     put it on top of the second name, and the names ran under it because nothing reserved its
     gutter. The chevron sits at the top with a gutter of its own, the rows of names are evenly
     spaced off the border, and a name too long for the field is cut with an ellipsis rather than
     widening it. */
  .mantine-MultiSelect-input {
    height: auto;
    min-height: 32px;
    padding: 3px 34px 3px 8px;
    display: flex;
    align-items: flex-start;
    font-size: 13px;
    border-color: light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
  }

  .mantine-MultiSelect-section[data-position='right'] {
    align-items: flex-start;
    padding-top: 7px;
  }

  .mantine-MultiSelect-pillsList {
    align-items: center;
    gap: 4px 6px;
  }

  /* A pill sized to its own text can't shrink, so a long fund name pushed itself past the field's
     edge and under the chevron, and shoved the search box onto a line of its own. It gives way and
     the name ends in an ellipsis instead. */
  /* A name that fills the line exactly leaves the search box nothing, and a flex line wraps before
     it shrinks — so the box dropped to a line of its own and a single master fund stood 68px tall.
     The name keeps everything but that much. */
  .mantine-MultiSelect-pill {
    flex: 0 1 auto;
    min-width: 0;
    max-width: calc(100% - 30px);
  }

  .mantine-MultiSelect-input:hover {
    border-color: light-dark(var(--mantine-color-gray-4), var(--mantine-color-dark-3));
  }

  /* Mantine keeps 100px for the search box, which pushed it onto a line of its own beside a named
     fund. It only has to be wide enough to start typing in; flex grows it from there. */
  /* Mantine keeps 100px for the search box, enough on its own to push a single name onto a second
     line. It only has to be wide enough to start typing in; flex grows it from there. */
  /* An empty search box holds no width. A flex line wraps before it shrinks, so any box reserved
     beside a long fund name went to a line of its own and made a one-line field 68px tall. It takes
     the leftover space when there is some, collapses when there isn't, and claims room to type in
     the moment it's focused.

     Three class names deep on purpose: the rule that gives every field in a record its 32px is
     written with two :not() tests for the checkboxes, and each of them counts towards specificity,
     so it outranked a two-class selector and kept handing the search box the full height. */
  /* 24px inside 4px of padding is 32 — the height of the segmented control beside it and of every
     other field in the record. Mantine gives its search box the full 32, which with the padding
     around it made the field 42 and left this one control standing taller than the line. */
  .masterCell .mantine-MultiSelect-input .mantine-PillsInputField-field {
    height: 24px;
    min-height: 0;
    flex: 1 1 0;
    min-width: 0;
    font-size: 13px;
  }

  .masterCell .mantine-MultiSelect-input .mantine-PillsInputField-field:focus {
    min-width: 60px;
  }

  /* A pane too narrow to finish the line: the field takes the row beneath instead of pushing the
     record into a horizontal scroll. Same element, same place in the markup. */
  @container (max-width: 1200px) {
    grid-template-columns: ${RECORD_NARROW};
    gap: 12px;

    .actionsCell {
      grid-column: 7;
    }

    .masterCell {
      grid-column: 4 / -1;
      grid-row: 2;
      padding-bottom: 2px;
    }

    .masterCell .field {
      max-width: 420px;
    }
  }
`;
